import $ from "jquery";

export class MapModule {

    constructor() {
        if ($('[data-lynx-map]').length) {
            window.initGoogleMaps = this.onApiReady.bind(this);
            this.loadApi();
        }
    }

    loadApi() {
        const key = 'AIzaSyBNOtSvOSxbouCtXYl3hNchcjQ1Nnd95UA';

        let src = "https://maps.googleapis.com/maps/api/js?callback=initGoogleMaps&key=" + key;
       // src = "https://maps.googleapis.com/maps/api/js?callback=initGoogleMaps";

        $.getScript(src, function (data, textStatus, jqxhr) { });
    }

    onApiReady() {
        const $set = $('[data-lynx-map]');

        for (let i = 0; i < $set.length; i++) {
            let $el = $($set[i]);

            let id = $el.attr('id');
            let lat = $el.data('latitude');
            let lng = $el.data('longitude');

            this.loadMap({
                elementId: id,
                latitude: parseFloat(lat),
                longitude: parseFloat(lng)
            });
        }
    }

    loadMap(office) {
        const styling = this.getMapStyle();

        let map = new google.maps.Map(document.getElementById(office.elementId), {
            center: { lat: office.latitude, lng: office.longitude },
            scrollwheel: false,
            zoom: 16,
            styles: styling,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
        });
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(office.latitude, office.longitude),
            map: map,
            draggable: false,
            icon : '/wp-content/themes/lynx-hedge/assets/images/Map-Pin.png'
        });
    }

    getMapStyle() {
        return [
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "saturation": "-65"
                    },
                    {
                        "lightness": "45"
                    },
                    {
                        "gamma": "1.78"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "geometry",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway.controlled_access",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": "-33"
                    },
                    {
                        "lightness": "22"
                    },
                    {
                        "gamma": "2.08"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "geometry",
                "stylers": [
                    {
                        "gamma": "2.08"
                    },
                    {
                        "hue": "#ffa200"
                    }
                ]
            },
            {
                "featureType": "transit.station.airport",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.station.rail",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit.station.rail",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "saturation": "-55"
                    },
                    {
                        "lightness": "-2"
                    },
                    {
                        "gamma": "1.88"
                    },
                    {
                        "hue": "#ffab00"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#bbd9e5"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/MapModule.js